import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {SubCategoryProps, translatedSubCategoryProps} from '../types';
import subCategoriesKeys from '../util/sub-categories-keys';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CreateSubCategoryProps
  extends Omit<SubCategoryProps, 'id' | 'category'> {
  categoryId: string;
}

export const translatedCreateSubCategoryProps: TranslatedKeys<CreateSubCategoryProps> =
  {
    ...translatedSubCategoryProps,
    categoryId: 'Categoria',
  };

const useCreateSubCategory = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: SubCategoryProps) =>
    create(subCategoriesKeys.list(), data);

  return useApiMutation<SubCategoryProps>({
    url: '/sub-categories',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar sub categoria',
    successTitle: 'Cadastrar sub categoria',
    successMessage: 'Sub categoria cadastrada com sucesso',
    redirectUrl: '/menu/sub-categories',
    onSuccess,
  });
};

export default useCreateSubCategory;
